<template>
  <appbar-view />
    <div class="main-content">
      <v-container>

        <!-- Boton de filtros -->

        <!-- Botón de filtros -->
        <v-row justify="end" class="mt-0 mb-2">
          <v-btn icon color="orange-darken-3" variant="flat" size="small" @click="toggleSearch">
            <v-icon>{{ showSearch ? "mdi-close" : "mdi-magnify" }}</v-icon>
          </v-btn>

          <v-text-field v-if="showSearch" ref="searchField" v-model="searchQuery" placeholder="Buscar productos"
            variant="outlined" color="orange-darken-3" hide-details density="comfortable" class="ml-2"
            style="max-width: 260px" />

          <v-col cols="auto">
            <v-tooltip text="Filtrar y ordenar">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" variant="outlined" color="grey-darken-1"
                  class="rounded-lg px-4 py-2 text-indigo-darken-4 d-flex align-center" @click="dialogFiltro = true">
                  <v-icon class="mr-2" color="grey-darken-1">mdi-filter-variant</v-icon>
                  <span class="font-weight-medium text-caption text-uppercase text-grey-darken-2">
                    Filtrar
                  </span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>

        <!-- Filtro de precios menor que y mayor que -->
        <v-dialog v-model="dialogFiltro" max-width="420">
          <v-card class="rounded-lg" color="text-white">
            <v-card-title class="bg-blue-darken-4 text-white">
              <v-icon class="mr-2">mdi-filter-cog</v-icon> Filtrar y ordenar
            </v-card-title>

            <v-card-text class="py-4">
              <v-switch v-model="sortByPrice" color="blue-darken-4" label="Ordenar por precio">
                <template v-slot:label>
                  <v-icon small class="mr-1"></v-icon>
                  <div class="text-blue-darken-4"><strong> De menor a mayor</strong></div>
                </template>
              </v-switch>
              <v-btn color="#223b78" variant="flat" class="rounded-lg px-4 text-white" @click="dialogFiltro = false">
                <v-icon class="mr-1">mdi-check</v-icon>
                Aplicar
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Botón del carrito flotante -->
        <!-- Boton de ver canasta  -->
        <v-btn icon class="floating-cart-btn" color="blue-darken-4" @click="cartDialog = true" elevation="10">
          <v-icon color="white" size="28">mdi-cart-outline</v-icon>
          <span v-if="totalCajas > 0" class="cart-badge">{{ totalCajas }}</span>
        </v-btn>
        <!-- Productos -->
        <v-row dense>
          <v-col v-for="product in filteredProducts" :key="product.id" cols="6" sm="6" md="4" lg="3"
            class="d-flex justify-center">
            <v-card class="pa-4" variant="flat" color="transparent" style="width: 240px">
              <v-row>
                <div class="d-flex align-center" style="position: relative">
                  <!-- Bloque de botones dinámicos -->
                  <div v-if="getProductQuantity(product) > 0" class="d-flex align-center mt-2">
                    <!-- Botón disminuir / eliminar -->
                    <v-btn icon @click="
                      getProductQuantity(product) === 1
                        ? removeFromCart(product)
                        : decreaseQuantity(product)
                      " variant="text" density="compact" :color="getProductQuantity(product) === 1 ? 'red' : 'orange-darken-1'
                        ">
                      <v-icon>
                        {{
                          getProductQuantity(product) === 1
                            ? "mdi-delete"
                            : "mdi-minus-circle"
                        }}
                      </v-icon>
                    </v-btn>

                    <!-- Cantidad actual -->
                    <span class="px-2 text-caption font-weight-bold" style="font-size: 1.2em">
                      {{ getProductQuantity(product) }}
                    </span>

                    <!-- Botón aumentar -->
                    <v-btn icon size="42" @click="increaseQuantity(product)" density="compact" variant="text"
                      color="blue-darken-4" :disabled="
                        !canAdd(product)
                        ">
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-row>

              <v-row class="d-flex justify-center" style="position: relative">
                <v-col cols="9" style="position: relative">
                  <!-- Imagen -->
                  <v-img :src="product.foto || 'default-image-url'" height="100px" class="rounded" :cover="false">
                    <template v-slot:placeholder>
                      <div class="d-flex align-center justify-center fill-height">
                        <v-progress-circular indeterminate color="grey-lighten-4" size="20"></v-progress-circular>
                      </div>
                    </template>
                  </v-img>

                  <!-- Icono de agregar -->
                  <v-icon color="blue-darken-4" size="42" v-ripple class="add-icon" style="
                      position: absolute;
                      top: 5px;
                      right: 5px;
                      background: white;
                      border-radius: 50%;
                      padding: 2px;
                      cursor: pointer;
                    " :disabled="!canAdd(product)" 
                      @click="
                        canAdd(product) &&
                        addToCart(product)
                      " :class="{
                      'v-icon--disabled': product.id_promocion
                        ? getProductQuantity(product) >= 1
                        : getProductQuantity(product) >= product.yfr_disponible,
                    }" :style="getProductQuantity(product) > 0
                        ? 'pointer-events: none; opacity: 0;'
                        : ''
                      ">
                    mdi-plus-circle
                  </v-icon>
                </v-col>
              </v-row>

              <!-- Precio / Promo -->
              <div class="w-full text-center mt-2 p-1 transition-shadow duration-300 space-y-1">
                <template v-if="product.id_promocion && product.promo_price">
                  <div class="text-gray-500 line-through font-semibold">
                    ${{ parseFloat(product.price).toFixed(2) }}
                  </div>
                  <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
                    ${{
                      (
                        product.price -
                        (product.price * product.promo_price) / 100
                      ).toFixed(2)
                    }}
                  </div>
                </template>
                <template v-else>
                  <div class="text-base sm:text-lg md:text-xl font-semibold text-blue-darken-4">
                    ${{ parseFloat(product.price).toFixed(2) }}
                  </div>
                </template>

                <!-- Nombre -->
                <div class="text-caption font-weight-bold text-grey-darken-3" style="line-height: 1.2; min-height: 2.4em; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
                  {{ product.nombre }}
                </div>

                <!-- SKU -->
                <div class="text-xs sm:text-sm font-medium text-gray-400">
                  SKU: {{ product.sku }}
                </div>

                <!-- Distintivo de promoción -->
                <div v-if="product.id_promocion && product.promo_price"
                  class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full">
                  Descuento {{ product.promo_price }}%
                </div>

                <!-- Agotado -->
                <div v-if="product.yfr_disponible <= 0" class="text-sm sm:text-base font-semibold text-red-500">
                  Agotado
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!-- Diálogo del carrito -->
        <CartDialog v-model="cartDialog" />
      </v-container>
    </div>
    <bottom-navigation />
</template>



<script setup>
import { ref, computed, onMounted, inject, nextTick } from "vue";
import { useRouter } from "vue-router";
import AppbarView from "../appbar/appbarView.vue";
import BottomNavigation from "../submenu/BottomNavigation.vue";
import CartDialog from "../Administrador/CarritoViewStore.vue";
import api from "@/services/api";
import { useUserStore } from "@/stores/userStore";

const router = useRouter();
const userStore = useUserStore();
const cartStore = inject("cartStore");

// Estado
const products = ref([]);
const searchQuery = ref("");
const showSearch = ref(false);
const searchField = ref(null);
const dialogFiltro = ref(false);
const sortByPrice = ref(false);
const cartDialog = ref(false);

// Carrito
const { addToCart, increaseQuantity, decreaseQuantity, removeFromCart, getProductQuantity } = cartStore;
const totalCajas = computed(() => cartStore.state.cart.reduce((total, item) => total + item.quantity, 0));

// Computed
const filteredProducts = computed(() => {
  let result = products.value.filter(p => 
    p.nombre.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
  if (sortByPrice.value) {
    result.sort((a, b) => a.price - b.price);
  }
  return result;
});

// Helpers
const canAdd = (product) => {
  const qty = getProductQuantity(product);
  if (product.id_promocion) return qty < 1;
  return qty < product.yfr_disponible;
};

const toggleSearch = async () => {
  if (showSearch.value) {
    searchQuery.value = "";
    showSearch.value = false;
  } else {
    showSearch.value = true;
    await nextTick();
    searchField.value?.focus();
  }
};

const fetchProducts = async () => {
  if (!userStore.isAuthenticated) return;
  const token = userStore.token;
  if (!token) return;

  // --- CACHE LOGIC ---
  const cacheKey = "products_139_suprema";
  const cacheTimeKey = "products_139_suprema_time";
  const cacheDuration = 15 * 60 * 1000; // 15 min
  const now = Date.now();

  const cachedData = localStorage.getItem(cacheKey);
  const cachedTime = localStorage.getItem(cacheTimeKey);

  if (cachedData && cachedTime && (now - Number(cachedTime) < cacheDuration)) {
    products.value = JSON.parse(cachedData);
    return;
  }

  try {
    const { data } = await api.get("https://mvexpress.mx/api/productos/139-suprema", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const mappedData = data.map(p => ({ ...p, price: p.price || 0 }));
    products.value = mappedData;

    // Save cache
    localStorage.setItem(cacheKey, JSON.stringify(mappedData));
    localStorage.setItem(cacheTimeKey, now.toString());
  } catch (error) {
    console.error("Error fetching products:", error);
  }
};

onMounted(async () => {
  if (!userStore.isSessionReady) await userStore.initSession();
  if (!userStore.isAuthenticated) {
    router.replace("/login");
    return;
  }
  await fetchProducts();
});
</script>



<style>
.snackbar-top {
  top: 30px !important;
  /* Ajusta la distancia del top */
  bottom: auto !important;
  z-index: 2000 !important;
}

.main-content {
  min-height: 100vh;
  padding-bottom: calc(env(safe-area-inset-bottom) + 220px) !important;
}

.floating-cart-btn {
  position: fixed;
  bottom: 150px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.marcas {
  display: flex;
  /* asegura que flex funcione */
  justify-content: center;
  /* centra elementos */
  overflow-x: auto;
  /* scroll horizontal */
  padding: 0 16px;
  /* margen interno */
  gap: 20px;
  /* espacio entre items */
  scroll-behavior: smooth;
  /* scroll suave */
}

.marcas::-webkit-scrollbar {
  display: none;
}

/* Cada item no se reduce */
.marcas .v-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* centra contenido dentro de la columna */
  padding: 0;
}

.fixed-cart-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  /* SUBE el botón justo arriba de la bottom nav */
  bottom: calc(env(safe-area-inset-bottom) + 70px);

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;

  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 16px;
  background-color: #fff;
}

.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: env(safe-area-inset-bottom);
  /* respeta la zona segura del teléfono */
  z-index: 9999;
}

/* Para Samsung donde env(safe-area) no se reporta correctamente */
@supports (bottom: env(safe-area-inset-bottom)) {
  .fixed-cart-btn {
    bottom: calc(max(env(safe-area-inset-bottom), 20px) + 70px);
  }
}
</style>